import { FadeUp } from "./Reveal";

export default function SectionLabel({ children, light = false, testid }) {
  return (
    <FadeUp className="mb-12 flex items-center gap-5">
      <span className={`h-px w-12 ${light ? "bg-bone/40" : "bg-ink/40"}`} />
      <span
        data-testid={testid}
        className={`font-sans text-[11px] uppercase tracking-[0.4em] ${light ? "text-manila" : "text-wine"}`}
      >
        {children}
      </span>
    </FadeUp>
  );
}
